import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

const storyTimer = {
    timer: 180000, // 180000 = 3 minutes
    pauseInterval: null,
    tlDesktop: null,
    tlMobile: null,
    isAnimating: false,
    $heroWrapper: $('.js-hero-story'),
    init: function () {
        if ($('.js-hero-story')) {
            $(window).on('load', function () {
                // 1. Calculate and load the dates
                loadDates()

                // 2. Create timer to pause the background
                storyTimer.playBgAnimation()
            })
        }

        ScrollTrigger.create({
            trigger: this.$heroWrapper,
            start: 'top bottom',
            end: 'bottom top',
            onToggle: ({ isActive }) => {
                clearTimeout(this.pauseInterval)
                if (isActive) {
                    storyTimer.playBgAnimation()
                } else {
                    storyTimer.pauseBgAnimation()
                }
            },
        })

        function loadDates() {
            let currentYear = new Date(),
                fullYear = currentYear.getFullYear(),
                datesListed = [],
                initialYear = 2007,
                length = 6,
                step = Math.floor((fullYear - initialYear) / length),
                $dates = $('.date-empty')

            for (let i = 0; i < length; i++) {
                if (initialYear + step === fullYear) {
                    datesListed.push(fullYear - 1)
                } else {
                    datesListed.push(initialYear + step)
                    initialYear = initialYear + step
                }
            }
            datesListed.push(fullYear)
            for (let i = 0; i <= length; i++) {
                $($dates[i]).text(datesListed[i])
            }
        }
    },
    playBgAnimation: function () {
        $('.hero-bg-inner').css('animation-play-state', '')
        storyTimer.pauseInterval = setTimeout(() => {
            $('.hero-bg-inner').css('animation-play-state', 'paused')
        }, storyTimer.timer)
    },
    pauseBgAnimation: function () {
        $('.hero-bg-inner').css('animation-play-state', 'paused')
    },
}

storyTimer.init()
